import React, { useState, useEffect, useRef } from 'react';
import PptxGenJS from 'pptxgenjs';
import './Admin.css';
import logo from '../../static/img/logorbg.png';

export default function SlideShow({ ankets, music, finalSlide = { imageUrl: null, trackUrl: null, enabled: false }, onClose }) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentTrackIndex, setCurrentTrackIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  const audioRef = useRef(null);
  const finalCustomAudioRef = useRef(null);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

  const hasConfiguredFinal = Boolean(finalSlide?.enabled && (finalSlide?.imageUrl || finalSlide?.trackUrl));

  const slides = [
    ...ankets.map((anketa) => ({
      type: 'anketa',
      data: anketa
    })),
    {
      type: 'final',
      data: ankets
    },
    ...(hasConfiguredFinal
      ? [{ type: 'finalCustom', data: finalSlide }]
      : []),
  ];

  const musicTracks = [music.greeting, music.meditation, music.ending].filter(Boolean);




  function downloadPresentation(ankets, musicForFinal, finalForSlide) {
    const pptx = new PptxGenJS();
    const base = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

    // Добавляем слайды по анкетам
    ankets.forEach((anketa) => {
      const slide = pptx.addSlide();
      slide.background = { color: 'FFFFFF' };

      // Заголовок (ФИО) по центру
      slide.addText(anketa.fullName, {
        x: 1, y: 0.5, w: 8, h: 1,
        fontSize: 28,
        bold: true,
        color: '003366',
        align: 'center'
      });

      // Намерение слева
      slide.addText(anketa.intention, {
        x: 0.5, y: 1.5, w: 4.5, h: 3,
        fontSize: 18,
        color: '444444',
        align: 'left',
        valign: 'top',
        lineSpacingMultiple: 1.2
      });

      // Фото справа
      const photoUrl = `${base}/${anketa.photos.split('|')[0]}`;
      slide.addImage({
        path: photoUrl,
        x: 5.5,
        y: 1.5,
        w: 4,
        h: 5,
        sizing: { type: 'contain', w: 4, h: 4 }  // сохранить пропорции
      });
    });

    // Слайд с коллажем участников
    const collageSlide = pptx.addSlide();
    collageSlide.background = { color: 'FFFFFF' };

    collageSlide.addText('Когерентное исцеление в авторизованной группе доктора Джо Диспенза', {
      x: 0.5, y: 0.3, w: '90%',
      fontSize: 20,
      bold: true,
      color: '222222',
      align: 'center'
    });

    ankets.forEach((anketa, idx) => {
      const col = idx % 3;
      const row = Math.floor(idx / 3);

      const x = 0.7 + col * 3;
      const y = 1.2 + row * 3;

      collageSlide.addImage({
        path: `${base}/${anketa.photos?.split('|')[0]}`,
        x, y,
        w: 2.5,
        h: 2.5,
        sizing: { type: 'contain', w: 2.5, h: 2.5 }
      });

      collageSlide.addText(anketa.fullName, {
        x, y: y + 2.6,
        w: 2.5,
        fontSize: 12,
        align: 'center'
      });
    });
    if (musicForFinal && musicForFinal.length > 0) {
      collageSlide.addMedia({
        type: 'audio',
        path: `${base}/${musicForFinal[0]}`,
        x: 0.5,
        y: 5.5,
        w: 1,
        h: 1
      });
    }

    if (finalForSlide?.enabled && (finalForSlide?.imageUrl || finalForSlide?.trackUrl)) {
      const customSlide = pptx.addSlide();
      customSlide.background = { color: 'FFFFFF' };
      if (finalForSlide.imageUrl) {
        customSlide.addImage({
          path: `${base}${finalForSlide.imageUrl}`,
          x: 0.5,
          y: 0.6,
          w: 9,
          h: 4.8,
          sizing: { type: 'contain', w: 9, h: 4.8 }
        });
      }
      if (finalForSlide.trackUrl) {
        customSlide.addMedia({
          type: 'audio',
          path: `${base}${finalForSlide.trackUrl}`,
          x: 0.5,
          y: 5.5,
          w: 1,
          h: 1
        });
      }
    }

    pptx.writeFile('Презентация.pptx');
  }




  const nextSlide = () => {
    if (currentSlide + 1 < slides.length) {
      setCurrentSlide(currentSlide + 1);
    } else {
      onClose();
    }
  };

  const prevSlide = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    } else {
      onClose();
    }
  };



  const slide = slides[currentSlide];

  // При завершении текущего трека — переключаемся на следующий
  const handleAudioEnded = () => {
    if (currentTrackIndex + 1 < musicTracks.length) {
      setCurrentTrackIndex(currentTrackIndex + 1);
    }
  };

  // Автоматически играет следующий трек, когда индекс трека меняется
  useEffect(() => {
    if (slide.type === 'final' && audioRef.current && currentTrackIndex !== 0) {
      audioRef.current.play().catch((e) => console.warn('Автовоспроизведение заблокировано'));
    }
  }, [currentTrackIndex, slide.type]);

  useEffect(() => {
    if (slide.type === 'final') {
      setCurrentTrackIndex(0);
      setIsPlaying(false);
    }
  }, [currentSlide, slide.type]);

  useEffect(() => {
    if (slide.type !== 'finalCustom' && finalCustomAudioRef.current) {
      finalCustomAudioRef.current.pause();
    }
  }, [currentSlide, slide.type]);

  return (
    <div
      style={{
        height: '100vh',
        textAlign: 'center',
      }}
      className={`slide_bg slide-show-root${
        slide.type === 'final' ? ' slide-show-root--final' : ''
      }${slide.type === 'finalCustom' ? ' slide-show-root--final-custom' : ''}`}
    >
      <img src={logo} alt="Logo" className="slide_logo" />
      <div className='slide_line' />
      {slide.type === 'anketa' && (
        <div className="anketa-slide">
          <h1 className="anketa-title">{slide.data.fullName}</h1>

          <div className="anketa-content">
            {/* <div className="anketa-intention">{slide.data.intention}</div> */}
            <div
              className="anketa-intention"
              dangerouslySetInnerHTML={{
                __html: slide.data.intention.replace(/\. /g, '.<br/>')
              }}
            ></div>


            <img
              className="anketa-photo"
              src={`${API_BASE_URL}/${slide.data.photos.split('|')[0]}`}
              alt="Фото"
            />
          </div>
        </div>
      )}

      {slide.type === 'finalCustom' && (
        <div className="final-custom-slide">
          <h3 className="final-custom-slide-title">Финальный слайд</h3>
          {slide.data.imageUrl && (
            <img
              className="final-custom-slide-img"
              src={`${API_BASE_URL}${slide.data.imageUrl}`}
              alt=""
            />
          )}
          {slide.data.trackUrl && (
            <audio
              ref={finalCustomAudioRef}
              src={`${API_BASE_URL}${slide.data.trackUrl}`}
              controls
              className="slide-audio-player final-custom-slide-audio"
            />
          )}
        </div>
      )}

      {slide.type === 'final' && (
        <div className="final-slide-wrapper">
          <div className="final-slide-nav-top">
            {currentSlide > 0 && (
              <button type="button" className="btn_next_slide" onClick={prevSlide}>
                Назад
              </button>
            )}
            <button type="button" className="btn_next_slide" onClick={nextSlide}>
              {currentSlide + 1 < slides.length ? 'Далее' : 'Закончить'}
            </button>
          </div>

          <div className="final-slide-heading">
            <h3 style={{ margin: 0 }}>
              Когерентное исцеление в авторизованной группе доктора Джо Диспенза
            </h3>
            <span
              onClick={() => downloadPresentation(ankets, musicTracks, finalSlide)}
              title="Скачать презентацию"
              style={{ fontSize: 22, cursor: 'pointer' }}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && downloadPresentation(ankets, musicTracks, finalSlide)}
            >
              ⬇️
            </span>
          </div>

          <div className="final-slide-photos-row">
            {ankets.map((anketa) => (
              <div className="cntr_photo" key={anketa.id}>
                <label className="final_label">{anketa.fullName}</label>
                <img
                  src={`${API_BASE_URL}/${anketa.photos?.split('|')[0]}`}
                  alt=""
                  className="final-slide-photo"
                />
              </div>
            ))}
          </div>

          {musicTracks.length > 0 && (
            <div className="final-slide-audio-block">
              <div className="final-slide-audio-inner">
                <audio
                  ref={audioRef}
                  src={`${API_BASE_URL}/${musicTracks[currentTrackIndex]}`}
                  onEnded={handleAudioEnded}
                  controls
                  className="slide-audio-player"
                />

                <div className="final-slide-track-btns">
                  <button
                    type="button"
                    onClick={() => {
                      if (currentTrackIndex > 0) {
                        setCurrentTrackIndex(currentTrackIndex - 1);
                        setIsPlaying(true);
                      }
                    }}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', transform: 'scaleX(-1)' }}
                  >
                    <svg width="50px" height="50px" viewBox="0 0 24 24" fill="#003153">
                      <path d="M6 6v12l8.5-6L6 6zm12 0v12h-2V6h2z" />
                    </svg>
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      if (isPlaying) {
                        audioRef.current?.pause();
                        setIsPlaying(false);
                      } else {
                        audioRef.current?.play();
                        setIsPlaying(true);
                      }
                    }}
                    style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                  >
                    {isPlaying ? (
                      <svg width="50px" height="50px" viewBox="0 0 24 24" fill="#003153">
                        <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
                      </svg>
                    ) : (
                      <svg width="50px" height="50px" viewBox="0 0 24 24" fill="#003153">
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    )}
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      if (currentTrackIndex + 1 < musicTracks.length) {
                        setCurrentTrackIndex(currentTrackIndex + 1);
                        setIsPlaying(true);
                      }
                    }}
                    style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                  >
                    <svg width="50px" height="50px" viewBox="0 0 24 24" fill="#003153">
                      <path d="M12 6v12l8.5-6zM3 6v12h2V6H3z" />
                    </svg>
                  </button>
                </div>
              </div>

              <p className="final-slide-now-playing">
                Сейчас играет: {musicTracks[currentTrackIndex].split('/').pop()}
              </p>
            </div>
          )}
        </div>
      )}


      <div className="cntr_btn_slide">
        {currentSlide > 0 && (
          <button type="button" className="btn_next_slide" onClick={prevSlide}>
            Назад
          </button>
        )}
        <button type="button" className="btn_next_slide" onClick={nextSlide}>
          {currentSlide + 1 < slides.length ? 'Далее' : 'Закончить'}
        </button>
      </div>



      {/* <div style={{ marginTop: 40 }}>

      </div> */}
    </div>
  );
}
